import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const reasonText = (reason, locationName) => {
  switch (reason) {
    case 'no_stripe_account':
      return "This location doesn't have a Stripe account set up yet.";
    case 'charges_not_enabled':
    case 'onboarding_incomplete':
      return `${locationName || 'This location'}'s Stripe account can't process invoices yet.`;
    default:
      return 'The invoice could not be created. This is usually a Stripe account or capability issue.';
  }
};

const StripeRecoveryModal = ({
  show,
  onHide,
  request,
  reason,
  locationName,
  detail,
  readyLocations,
  loadingReadyLocations,
  onFetchReadyLocations,
  onTransferAndInvoice,
  onOpenStripeDashboard,
  onRecheckReadiness,
}) => {
  const [selectedTransferLocation, setSelectedTransferLocation] = useState('');
  const [transferring, setTransferring] = useState(false);

  useEffect(() => {
    if (show && !readyLocations && !loadingReadyLocations && onFetchReadyLocations) {
      onFetchReadyLocations();
    }
  }, [show, readyLocations, loadingReadyLocations, onFetchReadyLocations]);

  const readyList = (readyLocations || []).filter((l) => l.ready);

  const handleDoTransfer = async () => {
    if (!selectedTransferLocation || !request) return;
    setTransferring(true);
    try {
      await onTransferAndInvoice(request, Number(selectedTransferLocation));
      setSelectedTransferLocation('');
      onHide();
    } finally {
      setTransferring(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Unable to create invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{reasonText(reason, locationName)}</p>
        {detail && <p className="text-muted small mb-3">{detail}</p>}

        <hr />

        <h6 className="font-weight-bold">Invoice from another location</h6>
        {loadingReadyLocations && (
          <p className="text-muted">Loading available locations…</p>
        )}
        {!loadingReadyLocations && readyList.length === 0 && (
          <p className="text-muted">No other locations are ready to invoice this job.</p>
        )}
        {!loadingReadyLocations && readyList.length > 0 && (
          <div>
            <div className="form-group">
              <select
                className="form-control"
                value={selectedTransferLocation}
                onChange={(e) => setSelectedTransferLocation(e.target.value)}
              >
                <option value="">Select a location…</option>
                {readyList.map((l) => (
                  <option key={l.locationId} value={String(l.locationId)}>
                    {l.locationName}
                  </option>
                ))}
              </select>
            </div>
            <Button
              variant="primary"
              onClick={handleDoTransfer}
              disabled={!selectedTransferLocation || transferring}
            >
              {transferring ? 'Working…' : 'Transfer & Invoice'}
            </Button>
          </div>
        )}

        <hr />

        <div className="d-flex flex-wrap" style={{ gap: '0.5rem' }}>
          <Button
            variant="outline-secondary"
            onClick={() => request && onOpenStripeDashboard(request.requestId)}
          >
            Fix Stripe Account
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => request && onRecheckReadiness(request.requestId)}
          >
            Check Again
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StripeRecoveryModal;
